import { useEffect, useState } from "react";
import { LifeBuoy, X } from "lucide-react";
import { Button } from "./ui/button";
import { exitImpersonation } from "../lib/impersonation";

function remaining(expiresAt) {
  if (!expiresAt) return "";
  const ms = new Date(expiresAt).getTime() - Date.now();
  if (ms <= 0) return "expired";
  const m = Math.ceil(ms / 60000);
  return m >= 60 ? "60 min left" : `${m} min left`;
}

export function ImpersonationBanner({ user }) {
  const imp = user?.impersonating;
  const [left, setLeft] = useState(() => remaining(imp?.expires_at));
  useEffect(() => {
    if (!imp) return undefined;
    const t = setInterval(() => setLeft(remaining(imp.expires_at)), 30000);
    return () => clearInterval(t);
  }, [imp]);
  if (!imp) return null;
  return (
    <div
      className="flex items-center justify-between gap-3 px-4 py-2 bg-orange-500 text-white text-sm shadow-md"
      role="status"
      data-testid="impersonation-banner"
    >
      <div className="flex items-center gap-2 min-w-0">
        <LifeBuoy size={16} className="shrink-0" />
        <span className="font-semibold truncate">Supporting {imp.tenant_name || "tenant"}</span>
        <span className="hidden sm:inline text-orange-100">· acting as their super admin · every action is audit-logged</span>
        {left && <span className="ml-1 rounded-full bg-white/20 px-2 py-0.5 text-[11px] font-medium" data-testid="impersonation-time-left">{left}</span>}
      </div>
      <Button
        size="sm"
        variant="secondary"
        className="h-7 bg-white text-orange-600 hover:bg-orange-50 shrink-0"
        onClick={exitImpersonation}
        data-testid="impersonation-exit-btn"
      >
        <X size={14} className="mr-1" /> Exit
      </Button>
    </div>
  );
}
